import * as React from "react";
import { BaseComponent } from "../../../../../../../react-core/Html/BaseComponent";
import { ProcessType } from "../../../../../../Shared/IST/Resource/Content";
import { CommissionChargeMessage } from "./CommissionChargeMessage";

interface ICommissionChargeCancelMsgProps {
    cancelAll?: boolean;
    processType: ProcessType;
}

interface ICommissionChargeCancelMsgState {}

export class CommissionChargeCancelMsg extends BaseComponent<
    ICommissionChargeCancelMsgProps,
    ICommissionChargeCancelMsgState
> {
    public render(): JSX.Element {
        return (
            <CommissionChargeMessage
                cancelAll={this.props.cancelAll}
                processType={this.props.processType}
                message="Completing this transaction will stop all existing commission and fee arrangements for affected products as per your terms and conditions."
            />
        );
    }
}
